var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApparaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 16,
    viewBox: "0 0 180 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1188 0.718994L30.5172 15.281H25.3992L15.2676 3.36139L5.1156 15.281H0L12.3984 0.718994H18.1188Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6468 0.718994C55.9756 0.718994 59.0128 3.17419 59.0128 6.45979C59.0128 9.74539 56.0368 12.221 52.6468 12.221H37.7932V15.2786H33.6328V0.718994H52.6468ZM52.6468 8.68579C53.854 8.68579 54.8524 7.68739 54.8524 6.45979C54.8524 5.23219 53.854 4.25419 52.6468 4.25419H37.7932V8.68579H52.6468Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1859 0.718994C85.5147 0.718994 88.5519 3.17419 88.5519 6.45979C88.5519 9.74539 85.5783 12.221 82.1859 12.221H67.3323V15.2786H63.1719V0.718994H82.1859ZM82.1859 8.68579C83.3931 8.68579 84.3915 7.68739 84.3915 6.45979C84.3915 5.23219 83.3931 4.25419 82.1859 4.25419H67.3323V8.68579H82.1859Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.048 0.718994L118.447 15.281H113.329L103.2 3.36259L93.0477 15.281H87.9297L100.328 0.718994H106.048Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.584 0.718994C143.913 0.718994 146.95 3.17419 146.95 6.45979C146.95 8.83099 145.37 10.8074 143.208 11.7026H145.266L147.408 15.281H142.747L140.917 12.2234H125.731V15.281H121.57V0.718994H140.584ZM140.584 8.68579C141.792 8.68579 142.79 7.68739 142.79 6.45979C142.79 5.23219 141.792 4.25419 140.584 4.25419H125.731V8.68579H140.584Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.603 0.718994L180.002 15.281H174.884L164.754 3.36259L154.602 15.281H149.484L161.883 0.718994H167.603Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApparaLogo);
export default __webpack_public_path__ + "static/media/appara_logo.6bc3947e19b216ff297e905574059cd3.svg";
export { ForwardRef as ReactComponent };